






































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateArticle from "./create-article.vue";
import EditArticle from "./edit-article.vue";
class PageArticleRequest extends PageRequest {
    title: string;
    articleCategoryId: number = null;
}

@Component({
    components: { CreateArticle, EditArticle }
})
export default class Articles extends AbpBase {
    edit() {
        this.editModalShow = true;
    }
    //filters
    pagerequest: PageArticleRequest = new PageArticleRequest();

    createModalShow: boolean = false;
    editModalShow: boolean = false;
    get list() {
        return this.$store.state.article.list;
    }
    get loading() {
        return this.$store.state.article.loading;
    }
    create() {
        this.createModalShow = true;
    }
    actionClick(row,e){
        switch (e) {
            case 'edit':
                this.$store.commit('article/edit',row);
                this.edit();
                break;
            case 'delete':
                this.$Modal.confirm({
                    title:this.L('Tips'),
                    content:this.L('ArticleDeleteWarningMessage'),
                    okText:this.L('Yes'),
                    cancelText:this.L('No'),
                    onOk:async()=>{
                        await this.$store.dispatch({
                            type:'article/delete',
                            data:row
                        })
                        await this.getpage();
                    }
                })
                break;
            case 'review':
                let routeData = this.$router.resolve({
                    name: "frontArticleDetail",
                    params:{id:row.id}
                });
                window.open(routeData.href, '_blank');
                break;
            default:
                break;
        }
    }
    pageChange(page: number) {
        this.$store.commit("article/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("article/setPageSize", pagesize);
        this.getpage();
    }
    search() {
        this.$store.commit("article/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        await this.$store.dispatch({
            type: "article/getAll",
            data: this.pagerequest
        });
    }
    get pageSize() {
        return this.$store.state.article.pageSize;
    }
    get totalCount() {
        return this.$store.state.article.totalCount;
    }
    get currentPage() {
        return this.$store.state.article.currentPage;
    }
    columns = [
        {
            title: this.L("Title"),
            key: "title",
            tooltip: true
        },
        {
            title: this.L("CategoryName"),
            width: 200,
            key: "articleCategoryName"
        },
        {
            title: this.L("ShowOnHome"),
            key: "showOnHome",
            width: 100,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.showOnHome ? this.L("Yes") : this.L("No")
                );
            }
        },
        {
            title: this.L("CreationTime"),
            key: "creationTime",
            width: 100,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    new Date(params.row.creationTime).toLocaleDateString()
                );
            }
        },
        {
            title: this.L("Actions"),
            slot: "action",
            width: 80,
            align: "center"
        }
    ];
    async created() {
        this.getpage();
        await this.$store.dispatch({
            type: "article/getCates"
        });
    }
}
